import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BadgeComponent } from '../../../../shared/ui';
import { formatCrc } from '../../../../shared/utils/currency.util';
import type { ProfilePrepurchase } from '../../data/profile-orders.models';
import { PROFILE_COPY } from '../../profile.copy';
import { formatIsoDate } from '../../utils/profile-format.util';
import { prepurchaseProofVariant, prepurchaseStateVariant } from '../../utils/profile-orders.util';

/**
 * «Precompras en curso» (W1b, A2b): una tarjeta por precompra viva, sin enlace (no hay detalle de precompra).
 * Solo pinta: quién pide, cuándo y si el bloque existe lo decide `ProfileOrdersComponent`, atado a la cuenta.
 *
 * Etiquetas (`state.label`, `proof.label`) y `note` son las del servidor, tal cual. Precompra ≠ apartado: ni saldo
 * ni fecha límite; la única nota es la de la API.
 */
@Component({
  selector: 'app-profile-prepurchases',
  imports: [BadgeComponent],
  templateUrl: './profile-prepurchases.component.html',
  styleUrl: './profile-prepurchases.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePrepurchasesComponent {
  readonly prepurchases = input.required<ProfilePrepurchase[]>();

  protected readonly title = PROFILE_COPY.ORDERS.PREPURCHASES_TITLE;
  protected readonly totalLabel = PROFILE_COPY.ORDER_DETAIL.TOTAL;
  protected readonly formatCrc = formatCrc;
  protected readonly formatIsoDate = formatIsoDate;
  protected readonly stateVariant = prepurchaseStateVariant;
  protected readonly proofVariant = prepurchaseProofVariant;

  protected quantityLabel(quantity: number): string {
    return PROFILE_COPY.ORDER_DETAIL.QUANTITY.replace('{n}', String(quantity));
  }
}
